import { useContext } from "react";
import { MainContentContext } from "../containers/MainContent/MainContentContext";

export const useSelectedPlant = () => {
    return useContext(MainContentContext);
};